import { render } from "./PharmacyPage.vue?vue&type=template&id=0d08f1c3"
import script from "./PharmacyPage.vue?vue&type=script&lang=js"
export * from "./PharmacyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__